// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__eb7lg","colBig":"styles_colBig__yq2Y-","colSmall":"styles_colSmall__3yYQ_","shopifyNameWrapper":"styles_shopifyNameWrapper__tG80O"};